module.exports = __webpack_public_path__ + "static/media/manOnTable.55b7cd11.svg";